export const POSTAL_CODES = [
  "1201 Genève",
  "1202 Genève",
  "1203 Genève",
  "1204 Genève",
  "1205 Genève",
  "1206 Genève",
  "1207 Genève",
  "1208 Genève",
  "1209 Genève",
  "1211 Genève",
  "1212 Grand-Lancy",
  "1213 Onex",
  "1214 Vernier",
  "1215 Genève-Aéroport",
  "1216 Cointrin",
  "1217 Meyrin",
  "1218 Le Grand-Saconnex",
  "1219 Châtelaine",
  "1220 Les Avanchets",
  "1222 Vésenaz",
  "1223 Cologny",
  "1224 Chêne-Bougeries",
  "1225 Chêne-Bourg",
  "1226 Thônex",
  "1227 Carouge",
  "1228 Plan-les-Ouates",
];
